namespace Matrix.Data {
    export interface SecurityOverrideForm {
        Name: Serenity.StringEditor;
        SecurityCode: Serenity.StringEditor;
        SecurityTypeCode: Serenity.LookupEditor;
        Issuer: Serenity.LookupEditor;
        IssuerCode: FormatLookupEditor;
        LocalCurrencyCode: Serenity.LookupEditor;
        ExposureMultiplier: Serenity.DecimalEditor;
        AssociatedAccountCode: FormatServiceLookupEditor;
        CountryOfIssueCode: Serenity.LookupEditor;
        CountryOfRiskCode: Serenity.LookupEditor;
        CurrencyOfRiskCode: Serenity.LookupEditor;
        Sedol: Serenity.StringEditor;
        RIC: Serenity.StringEditor;
        Isin: Serenity.StringEditor;
        Cusip: Serenity.StringEditor;
        Figi: Serenity.StringEditor;
        Ticker: Serenity.StringEditor;
        InternalSecurityCode: Serenity.StringEditor;
        SecurityId: Serenity.IntegerEditor;
        DealParentCode: Serenity.StringEditor;
        ClearerReference: Serenity.StringEditor;
        RedCode: Serenity.StringEditor;
        SpLtRating: Serenity.LookupEditor;
        SpStRating: Serenity.LookupEditor;
        MoodysLtRating: Serenity.LookupEditor;
        MoodysStRating: Serenity.LookupEditor;
        FitchLtRating: Serenity.LookupEditor;
        FitchStRating: Serenity.LookupEditor;
        InternalLtRating: Serenity.StringEditor;
        InternalStRating: Serenity.StringEditor;
        CouponRate: Serenity.DecimalEditor;
        MaturityDate: Serenity.DateEditor;
        FixedOrFloat: Serenity.StringEditor;
        FloatIndex: Serenity.StringEditor;
        InflationIndexLag: Serenity.StringEditor;
        InterestTerm: Serenity.StringEditor;
        Spread: Serenity.DecimalEditor;
        AllIn: Serenity.DecimalEditor;
        InterestCcy: Serenity.LookupEditor;
        PaymentFrequency: Serenity.StringEditor;
        PaymentBusDayConvention: Serenity.StringEditor;
        PaymentCalendar: Serenity.StringEditor;
        FirstPaymentDate: Serenity.DateEditor;
        DayCountBasis: Serenity.StringEditor;
        ResetFrequency: Serenity.StringEditor;
        ResetBusDayConvention: Serenity.StringEditor;
        ResetCalendar: Serenity.StringEditor;
        CreditEvents: Serenity.StringEditor;
        Guarantor: Serenity.StringEditor;
        TradeDate: Serenity.DateEditor;
        EffectiveDate: Serenity.DateEditor;
        BrokerCode: FormatLookupEditor;
        Strategy: Serenity.StringEditor;
        OptionStyle: Serenity.StringEditor;
        ExerciseStyle: Serenity.StringEditor;
        PutOrCall: ListEditor;
        StrikePrice: Serenity.DecimalEditor;
        StrikeCurrency: Serenity.StringEditor;
        Premium: Serenity.DecimalEditor;
        PremiumCcy: Serenity.LookupEditor;
        PayOrRec: Serenity.StringEditor;
        BorrowerCode: FormatLookupEditor;
        GicsSelection: ModelTargetPicker;
        GicsSector: Serenity.StringEditor;
        GicsIndustryGroup: Serenity.StringEditor;
        GicsIndustry: Serenity.StringEditor;
        GicsSubIndustry: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityOverrideForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityOverride';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityOverrideForm.init)  {
                SecurityOverrideForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = FormatLookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = FormatServiceLookupEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.DateEditor;
                var w7 = ListEditor;
                var w8 = ModelTargetPicker;
                var w9 = StaticTextBlock;
                var w10 = ReadOnlyDateTime;

                Q.initFormType(SecurityOverrideForm, [
                    'Name', w0,
                    'SecurityCode', w0,
                    'SecurityTypeCode', w1,
                    'Issuer', w1,
                    'IssuerCode', w2,
                    'LocalCurrencyCode', w1,
                    'ExposureMultiplier', w3,
                    'AssociatedAccountCode', w4,
                    'CountryOfIssueCode', w1,
                    'CountryOfRiskCode', w1,
                    'CurrencyOfRiskCode', w1,
                    'Sedol', w0,
                    'RIC', w0,
                    'Isin', w0,
                    'Cusip', w0,
                    'Figi', w0,
                    'Ticker', w0,
                    'InternalSecurityCode', w0,
                    'SecurityId', w5,
                    'DealParentCode', w0,
                    'ClearerReference', w0,
                    'RedCode', w0,
                    'SpLtRating', w1,
                    'SpStRating', w1,
                    'MoodysLtRating', w1,
                    'MoodysStRating', w1,
                    'FitchLtRating', w1,
                    'FitchStRating', w1,
                    'InternalLtRating', w0,
                    'InternalStRating', w0,
                    'CouponRate', w3,
                    'MaturityDate', w6,
                    'FixedOrFloat', w0,
                    'FloatIndex', w0,
                    'InflationIndexLag', w0,
                    'InterestTerm', w0,
                    'Spread', w3,
                    'AllIn', w3,
                    'InterestCcy', w1,
                    'PaymentFrequency', w0,
                    'PaymentBusDayConvention', w0,
                    'PaymentCalendar', w0,
                    'FirstPaymentDate', w6,
                    'DayCountBasis', w0,
                    'ResetFrequency', w0,
                    'ResetBusDayConvention', w0,
                    'ResetCalendar', w0,
                    'CreditEvents', w0,
                    'Guarantor', w0,
                    'TradeDate', w6,
                    'EffectiveDate', w6,
                    'BrokerCode', w2,
                    'Strategy', w0,
                    'OptionStyle', w0,
                    'ExerciseStyle', w0,
                    'PutOrCall', w7,
                    'StrikePrice', w3,
                    'StrikeCurrency', w0,
                    'Premium', w3,
                    'PremiumCcy', w1,
                    'PayOrRec', w0,
                    'BorrowerCode', w2,
                    'GicsSelection', w8,
                    'GicsSector', w0,
                    'GicsIndustryGroup', w0,
                    'GicsIndustry', w0,
                    'GicsSubIndustry', w0,
                    'CreatedBy', w9,
                    'CreatedWhen', w10,
                    'UpdatedBy', w9,
                    'UpdatedWhen', w10,
                    'Version', w9
                ]);
            }
        }
    }
}
